import $ from "jquery";
import { createGuid, contentMeta, getDynData, truncateWithElipsis } from "#scripts/general_functions";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import language from "#scripts/translation";
import cardslist, { carditem } from "#templates/modules/cardlisting_template";
import { AimError } from "#scripts/tools/aimlog.js";
import { getLangForApi } from "#scripts/cmsapi.js";

export const getItems = async (category, load, from, callback) => {
  const senddata = {
    categoryId: category,
    subscriptionId: window.serverdata.configMeta.aim.clientId,
  };

  const allowedContentTypes = [
    "5be9ba0d-3682-4493-9587-306a99911bf3", //Artikkel
    "8ee596e3-98cc-43e0-b785-96cc6325773c", //Artikkel med bilde
    "93847071-c959-4ce5-a79a-686af7dbd419", //Enhet
    "e662f30f-ecd9-4974-8657-35b726365572", //Temaside
    "09ceb3f2-3b86-4a5f-a823-16c6210982bc", //Kampanje
    "a72e7e73-1864-46ee-adba-814d05b51d9e", //Prosjekt
    "fd54728e-1956-433b-a33b-a7f95023dd37", //Fokusartikkel
    "1bb71f41-4ee6-4394-b78f-3202e2f5eeda", //Transportside
  ];

  const apiCall = `${window.apiUrl}/Public/articles`;
  const apiParameters = `?subscriptionId=${window.serverdata.configMeta.aim.clientId
    }&category=${category}&contentTypes=${allowedContentTypes.join(",")}&language=${getLangForApi()}&limit=${load}&offset=${from}&includeCategories=true&getRecursiveContent=true&LanguageMode=Strict`;

  try {
    const response = await fetch(apiCall + apiParameters, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    callback(data);
  } catch (error) {
    AimError(`API Error: ${error.toString()}`, `${window.apiUrl}/Public/articles`);
  }
};

export const getSingleItem = async (contentId, callback) => {
  const apiCall = `${window.apiUrl}/Public/articles/${contentId}`;
  const apiParameters = `?subscriptionId=${window.serverdata.configMeta.aim.clientId}`;

  try {
    const response = await fetch(apiCall + apiParameters, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    callback(data);
  }
  catch (error) {
    const errorMessage = error.responseText ? error.responseText.toString() : error.message;
    AimError(`API Error: ${errorMessage}`, `${window.apiUrl}/Public/articles`);
  }
};

export const getCategoryFromString = async (category) => {
  const response = await fetch(`${window.apiUrl}/CategoryApi/getbytitle/${category}`);
  const json = await response.json();

  if (json.length > 0) {
    for (const cat of json) {
      if (cat.subscriptionId === window.serverdata.configMeta.aim.clientId) {
        return cat.categoryId;
      }
    }
  }
};

export const cardsFront = (
  category,
  maxItems,
  moduleTitle,
  moreText = "",
  moreLink = "",
  cardDesign = "",
  showCategories = true,
  sortOrder = "sortByDate",
  moduleCardColor = "",
) => {
  const categoryId = category;
  const moduleGuid = createGuid();
  let sortAsc = 1;

  if (!category) {
    return "";
  }

  const idList = category.split(/[;,]/);
  if (idList.length > 1) {
    const cards = [];

    const promises = idList.map((id) => {
      return new Promise((resolve) => {
        getSingleItem(id.trim(), (data) => {
          const cardItem = createCardItem(data, showCategories, categoryId, sortOrder, sortAsc, cards, moduleCardColor);
          if (cardItem) {
            let cardSortOrder = data.published ? data.published : data.modified;

            switch (sortOrder) {
              case "sortByDate":
                cardSortOrder = data.published ? data.published : data.modified;
                sortAsc = -1;
                break;
              case "sortByTitle":
                cardSortOrder = data.title;
                sortAsc = 1;
                break;
            }
            cards.push({
              item: cardItem,
              order: cardSortOrder,
            });
          }
          resolve();
        });
      });
    });
    Promise.all(promises).then(() => {
      let sortedCards = cards
      // let sortedCards = cards.sort((a, b) => {
      //   if (a.order > b.order) return 1 * sortAsc;
      //   if (a.order < b.order) return -1 * sortAsc;
      //   return 0;
      // });

      // sortedCards = sortedCards.slice(0, maxItems);

      const cardsContainer = document.getElementById(`cards_${moduleGuid}`);
      if (sortedCards.length < 1) {
        cardsContainer.innerHTML = "";
      } else {
        const joinedCards = sortedCards.map((e) => e.item).join("");
        cardsContainer.innerHTML = joinedCards;
        // TODO: Handle case where there are more cards than displayed
        // if (cards.length < data?.length) {
        // }
      }
    });
  } else {
    getItems(category, maxItems * 2, 0, (_data) => {
      const cards = [];
      const data = _data.listOfContent;

      if (data?.length > 0) {
        for (const item of data) {
          const cardItem = createCardItem(item, showCategories, categoryId, sortOrder, sortAsc, cards, moduleCardColor);
          if (cardItem) {
            let cardSortOrder = cardItem.published ? cardItem.published : cardItem.modified;

            switch (sortOrder) {
              case "sortByDate":
                cardSortOrder = cardItem.published ? cardItem.published : cardItem.modified;
                sortAsc = -1;
                break;
              case "sortByTitle":
                cardSortOrder = cardItem.title;
                sortAsc = 1;
                break;
            }
            cards.push({
              item: cardItem,
              order: cardSortOrder,
            });
          }
        }
      }

      let sortedCards = cards.sort((a, b) => {
        if (a.order > b.order) return 1 * sortAsc;
        if (a.order < b.order) return -1 * sortAsc;
        return 0;
      });

      sortedCards = sortedCards.slice(0, maxItems);

      const cardsContainer = document.getElementById(`cards_${moduleGuid}`);
      if (sortedCards.length < 1) {
        cardsContainer.innerHTML = "";
      } else {
        const joinedCards = sortedCards.map((e) => e.item).join("");
        cardsContainer.innerHTML = joinedCards;
        if (cards.length < data.length) {
          // Handle case where there are more cards than displayed
        }
      }
    });
  }

  return cardslist({
    id: moduleGuid,
    title: moduleTitle !== undefined ? moduleTitle : "",
    // moretitle: language("CARDS_SEEALL") !== "CARDS_SEEALL" ? language("CARDS_SEEALL") : moreText !== "" ? moreText : "Se mere...",
    moretitle: moreText !== "" ? moreText : "",
    morelink: moreLink !== "" ? moreLink : `/nav/${category}`,
    cardDesign,
  });
};

function createCardItem (card, showCategories, categoryId, sortOrder, sortAsc, cards, moduleCardColor) {
  const meta = contentMeta(card);
  const cardGuid = createGuid();

  const isTransportPage = card.contentTypeGuid === "1bb71f41-4ee6-4394-b78f-3202e2f5eeda";
  const shouldShow = isTransportPage ? showCategories && card.categories[0].categoryId !== categoryId : true;
  if (card.title && shouldShow && card.isVisibleInNavigation) {
    let image = "";

    if (meta.imageContentId) {
      if (card.imagePath) {
        image = `<div class="card__image_container"><img src="${card.imagePath}" id="card__${cardGuid}" class="card__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
      } else {
        image = `<div class="card__image_container"><img src="" id="card__${cardGuid}" class="card__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
        getImageByContentId(meta.imageContentId, (img) => {
          const cardImage = document.getElementById(`card__${cardGuid}`);
          if (cardImage) {
            cardImage.setAttribute("data-src", img.url);
            cardImage.setAttribute("src", "/images/transparent.png");
            cardImage.setAttribute("alt", "");
            cardImage.setAttribute("data-imagehotspot", `${img.imageHotspotX},${img.imageHotspotY}`);
            setResponsiveImage(cardImage);
          }
        });
      }
    }

    let link = `${isTransportPage ? "" : "/artikkel"}/${card.nameInUrl !== "" ? card.nameInUrl : card.contentId}`;
    let dynLink = "";
    if (meta.currentDynamiskMalContent) {
      dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res || getDynData(meta, "86f9e817-0a00-494b-bc81-0129840ab636").res;
    }

    if (dynLink) {
      link = dynLink;
    }

    return carditem({
      link,
      image,
      title: card.title,
      intro: truncateWithElipsis(card.intro, 170),
      tag: card?.tags[0]?.title,
      color: moduleCardColor,
    })
  };
};

